import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../services/api';

const formatDateOnly = (value, fallbackLabel = 'Unknown') => {
  if (!value) return fallbackLabel;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallbackLabel;
  return date.toLocaleDateString('en-US');
};

const formatDateTime = (value) => {
  if (!value) return 'Unknown';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  return date.toLocaleString();
};

const OpsOrgApiKeys = () => {
  const { orgId } = useParams();
  const [apiKeys, setApiKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [detailsKey, setDetailsKey] = useState(null);

  useEffect(() => {
    let mounted = true;
    const loadKeys = async () => {
      setLoading(true);
      setStatus({ type: '', message: '' });
      try {
        const response = await api.get(`/acct-mgmt/v1/orgs/${orgId}/api-keys`);
        if (!mounted) return;
        setApiKeys(response.data.keys || []);
      } catch (err) {
        if (!mounted) return;
        setStatus({ type: 'danger', message: err.response?.data?.error || 'Failed to load API keys.' });
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (orgId) loadKeys();
    return () => {
      mounted = false;
    };
  }, [orgId]);

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">API Keys</h5>
        {status.message && (
          <div className={`alert alert-${status.type}`} role="alert">{status.message}</div>
        )}
        {loading ? (
          <div className="text-muted">Loading API keys...</div>
        ) : (
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Public Key</th>
                  <th>Status</th>
                  <th>Created By</th>
                  <th>Creation Date</th>
                  <th>Last Utilized</th>
                </tr>
              </thead>
              <tbody>
                {apiKeys.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-muted text-center">No API keys found.</td>
                  </tr>
                )}
                {apiKeys.map((key) => (
                  <tr key={key.key_id_public}>
                    <td>{key.friendly_name || '—'}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => setDetailsKey(key)}
                      >
                        View Details
                      </button>
                    </td>
                    <td>{key.active_flag ? 'Active' : 'Inactive'}</td>
                    <td>{key.created_by_name || 'Unknown'}</td>
                    <td>{formatDateOnly(key.created_at)}</td>
                    <td>{key.last_utilized ? formatDateOnly(key.last_utilized) : 'Never'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {detailsKey && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">API key details</h5>
                  <button type="button" className="btn-close" onClick={() => setDetailsKey(null)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-2"><strong>Name:</strong> {detailsKey.friendly_name || '—'}</div>
                  <div className="mb-2"><strong>Public key:</strong> {detailsKey.key_id_public}</div>
                  <div className="mb-2"><strong>Status:</strong> {detailsKey.active_flag ? 'Active' : 'Inactive'}</div>
                  <div className="mb-2"><strong>Last utilized:</strong> {detailsKey.last_utilized ? formatDateTime(detailsKey.last_utilized) : 'Never'}</div>
                  <div className="mb-2"><strong>Created by:</strong> {detailsKey.created_by_name || 'Unknown'}</div>
                  <div className="mb-2"><strong>Created:</strong> {formatDateTime(detailsKey.created_at)}</div>
                  <div className="mb-2"><strong>Last edited by:</strong> {detailsKey.updated_by_name || 'Unknown'}</div>
                  <div className="mb-0"><strong>Last edit:</strong> {formatDateTime(detailsKey.updated_at)}</div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-outline-secondary" onClick={() => setDetailsKey(null)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OpsOrgApiKeys;
